import { Link } from "react-router-dom";
import type { Article } from "@/mocks/data";

export default function ArticleCard({ article }: { article: Article }) {
  return (
    <article className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-transform hover:-translate-y-1">
      <Link to={`/article/${article.id}`} className="block" aria-label={`阅读${article.title}`}>
        <div className="relative h-48 w-full overflow-hidden sm:h-40">
          <img
            src={article.cover}
            alt={`${article.title}配图`}
            title={`${article.title}配图`}
            loading="lazy"
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="p-4">
          <h3 className="line-clamp-2 font-heading text-base font-bold leading-snug text-foreground-900 group-hover:text-primary-700">
            {article.title}
          </h3>
          <p className="mt-2 line-clamp-2 text-sm text-foreground-600">{article.excerpt}</p>
          <div className="mt-3 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-eye-line" aria-hidden="true"></i>
              {(article.views / 1000).toFixed(1)}k
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-heart-line" aria-hidden="true"></i>
              {(article.likes / 1000).toFixed(1)}k
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-chat-3-line" aria-hidden="true"></i>
              {article.comments}
            </span>
            <span className="ml-auto whitespace-nowrap text-foreground-400">{article.date}</span>
          </div>
        </div>
      </Link>
    </article>
  );
}